var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.36621 7.74219H9.42574V15.4987H8.36621V7.74219Z",
    fill: "#778CA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2995 0H7.49153C6.99966 0 6.52808 0.195316 6.18029 0.543057C5.83253 0.890821 5.63724 1.36237 5.63724 1.85429V2.55369H0.529763C0.237066 2.55369 0 2.79077 0 3.08345C0 3.37597 0.237076 3.61322 0.529763 3.61322H1.93632V16.8211C1.93632 17.6643 2.27133 18.4727 2.86746 19.069C3.46359 19.6652 4.27217 20 5.11537 20H12.6756C13.5187 20 14.3274 19.6652 14.9235 19.069C15.5196 18.4728 15.8546 17.6643 15.8546 16.8211V3.61322H17.2612C17.5539 3.61322 17.791 3.37596 17.791 3.08345C17.791 2.79076 17.5539 2.55369 17.2612 2.55369H12.1537V1.85429C12.1537 1.36242 11.9584 0.89084 11.6107 0.543057C11.2629 0.195292 10.7914 0 10.2994 0H10.2995ZM6.69416 1.85429C6.69416 1.64346 6.77787 1.4413 6.92681 1.29236C7.07593 1.14324 7.27808 1.05953 7.48893 1.05953H10.2995C10.5103 1.05953 10.7125 1.14324 10.8614 1.29236C11.0105 1.44129 11.0942 1.64345 11.0942 1.85429V2.55369H6.69676L6.69416 1.85429ZM14.7951 3.61327V16.8212C14.7951 17.3833 14.5719 17.9223 14.1744 18.3198C13.7769 18.7173 13.2379 18.9405 12.6758 18.9405H5.11556C4.55344 18.9405 4.01446 18.7173 3.61696 18.3198C3.21945 17.9223 2.99627 17.3833 2.99627 16.8212V3.61327H14.7951Z",
    fill: "#778CA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18652 7.74219H6.24605V15.4987H5.18652V7.74219Z",
    fill: "#778CA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5449 7.74219H12.6045V15.4987H11.5449V7.74219Z",
    fill: "#778CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.7bf6045bf16fc08cdd526b15b582aad7.svg";
export { ForwardRef as ReactComponent };